export default __webpack_public_path__ + "static/media/ship-solid.1007dd88.svg";